export default "__VITE_ASSET__fcf5655d__"